export default __webpack_public_path__ + "static/media/a023-startup4-short.095f47ad.png";